module.exports = __webpack_public_path__ + "img/charging-station-11.d6c3e755.svg";